/** @jsxImportSource @emotion/react */
import { forwardRef, InputHTMLAttributes, ReactNode, ChangeEvent } from 'react';

import * as S from './style';
import { InlineCss } from '../types/common';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement>, InlineCss {
  hasError?: boolean;
  leading?: ReactNode;
  trailing?: ReactNode;
  format?: (value: string) => string;
  parse?: (value: string) => string;
  wrapperClassName?: string;
}

// eslint-disable-next-line react/display-name
const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { inlineCss, leading, trailing, hasError, onChange, format, wrapperClassName = '', ...props },
    ref,
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      const formattedValue = format ? format(value) : value;
      e.target.value = formattedValue;

      if (onChange) {
        onChange(e);
      }
    };
    return (
      <S.Wrapper className={wrapperClassName} hasError={hasError}>
        {leading}
        <S.Input ref={ref} css={inlineCss} onChange={handleChange} {...props} />
        {trailing}
      </S.Wrapper>
    );
  },
);

export default Input;
